// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"342":"389bf733","453":"444528af","702":"923279ba","715":"2e8904df"}[chunkId] + ".chunk.js";
};